import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ITerminalIdField {
	changeTerminalId: (value: string) => void;
}

const TerminalIdField: React.FC<ITerminalIdField> = ({ changeTerminalId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterTerminalId') }], [t]);

	return (
		<FormInput
			testId="TerminalIdField"
			name="terminalId"
			label="terminalIDLabel"
			onChange={changeTerminalId}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(TerminalIdField);
